
.cardLink {
    text-decoration: none;
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    z-index: -1;
}
.cardImage {
    width: 100%;
    height: 235px;
    object-fit: cover;
}

.cardContent {
    background-color: #3caeb0;
    color: #FFFFFF;
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
}

.cardDecoration {
    background-color: #ffe9e2;
    z-index: -1;
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
}

.cardHeading {
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
}

.cardText {
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
}

.cardLink:hover .cardContent {
    background-color: #FFFFFF;
}

.cardLink:hover .cardDecoration {
    background-color: #3caeb0;
}

.cardLink:hover .cardText {
    color: black;
}

.cardLink:hover .cardHeading {
    color: #3caeb0;
}
